import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from '../../../auth/AuthContext'
import { clip, isEmail } from '../../../utils/inputs'
import { AFTER_ACTIVATE_PATH, errorMessage } from '../common/register-common'

export const CODE_LENGTH = 6
const EMAIL_MAX = 100
const PASSWORD_MIN = 8
const PASSWORD_MAX = 50
const ACTIVATE_ERROR = 'No pudimos activar tu cuenta. Revisa el código e inténtalo de nuevo.'

export const useRegisterActivateModel = () => {
    const { activate } = useAuth()
    const navigate = useNavigate()
    const { search } = useLocation()
    const params = new URLSearchParams(search)
    const linkEmail = (params.get('email') || '').trim()

    const [email, setEmail] = useState(linkEmail)
    const [codigo, setCodigo] = useState(() => (params.get('codigo') || '').replace(/\D/g, '').slice(0, CODE_LENGTH))
    const [password, setPassword] = useState('')
    const [repeated, setRepeated] = useState('')
    const [showPassword, setShowPassword] = useState(false)
    const [tried, setTried] = useState(false)
    const [loading, setLoading] = useState(false)
    const [submitError, setSubmitError] = useState('')

    const emailOk = isEmail(email)
    const codigoOk = codigo.length === CODE_LENGTH
    const passwordOk = password.length >= PASSWORD_MIN
    const repeatedOk = Boolean(repeated) && repeated === password

    const invalid = {
        email: tried && !emailOk,
        codigo: tried && !codigoOk,
        password: tried && !passwordOk,
        repeated: (tried && !repeatedOk) || (repeated.length >= password.length && Boolean(repeated) && repeated !== password),
    }

    const submit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault()
        if (!emailOk || !codigoOk || !passwordOk || !repeatedOk) {
            setTried(true)
            return
        }
        setLoading(true)
        setSubmitError('')
        try {
            await activate({ correo: email.trim(), codigo, password })
            navigate(AFTER_ACTIVATE_PATH, { replace: true })
        } catch (error) {
            setSubmitError(errorMessage(error, ACTIVATE_ERROR))
        } finally {
            setLoading(false)
        }
    }

    return {
        email,
        /** El correo viene en el enlace; solo se captura si se abrió la página sin él. */
        emailFromLink: Boolean(linkEmail),
        codigo,
        password,
        repeated,
        showPassword,
        loading,
        invalid,
        submitError,
        passwordMin: PASSWORD_MIN,
        setEmail: (value: string) => setEmail(clip(value.trim(), EMAIL_MAX)),
        setCodigo: (value: string) => setCodigo(value.replace(/\D/g, '').slice(0, CODE_LENGTH)),
        setPassword: (value: string) => setPassword(clip(value, PASSWORD_MAX)),
        setRepeated: (value: string) => setRepeated(clip(value, PASSWORD_MAX)),
        toggleShowPassword: () => setShowPassword((value) => !value),
        submit,
    }
}
